import en from './en';
import defaultLocale from './default';

export default {
  en: { translation: en },
  default: { translation: defaultLocale },
};
